<mat-button-toggle-group
    [value]="selectedOption"
    (change)="onOptionSelect.emit($event.value)"
    [hideSingleSelectionIndicator]="true"
    [attr.aria-label]="ariaLabel | translate">
    @for (option of options; track option) {
        <mat-button-toggle [value]="option.value" [class]="option.class" [attr.data-cy]="'pill-toggle-' + option.value">
            {{ option.label | translate }}
        </mat-button-toggle>
    }
</mat-button-toggle-group>
